import {translations} from 'presentation/translations-new';

export type Status = 'pending' | 'finished';

const {status} = translations['pt-br'].privateFlow.refund;

enum StatusEnum {
	PENDING = 'pending',
	FINISHED = 'finished',
}

const cardStyleByStatus = {
	[StatusEnum.PENDING]: {
		textColor: 'primary.dark',
		$variant: StatusEnum.PENDING,
	},
	[StatusEnum.FINISHED]: {
		textColor: 'primary.dark',
		$variant: StatusEnum.PENDING,
	},
};

const chipByStatus: Record<
	StatusEnum,
	{
		color: 'default' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning';
		label: string;
	}
> = {
	[StatusEnum.PENDING]: {
		color: 'primary',
		label: '',
	},
	[StatusEnum.FINISHED]: {
		color: 'primary',
		label: status.edit,
	},
};

export {cardStyleByStatus, chipByStatus, StatusEnum};
